export default "__VITE_ASSET__BrRfxyev__"